<template>
<div class="page page_baocuo">
    <!-- <div class="list">
        <div class="item">
            <div class="item_nr">
                <div class="item_nr_l">
                    <img :src="image" alt="" class="tu" />
                </div>
                <div class="item_nr_r">
                    <div class="item_nr_r_t">
                        <div class="title slh">
                            {{ title }}
                        </div>
                        <div class="info">
                            <span class="price"><span class="tag_cash">¥</span>{{ price }}</span>
                            <span class="nums">x{{ count }}</span>
                        </div>
                    </div>
                    <div class="sku">{{ spec }}</div>
                </div>
            </div>
        </div>
    </div> -->
    <div class="filed">
        <div class="filed_title">评论</div>
        <div class="filed_nr">
            <van-field v-model="comment" type="textarea" placeholder="买家秀..." />
        </div>
    </div>
    <div class="filed">
        <div class="filed_title">图片</div>
        <div class="filed_nr">
            <div class="upload-images">
                <div class="img-box" v-for="(item, index) in imglist" :key="index">
                    <div class="icon-po">
                        <!-- <img class="image" :src="item" /> -->
                        <van-image :show-error="false" :show-loading="false" class="image" fit="contain" :src="imageUrl+item" />
                    </div>
                    <div class="del" @click="imgDel(index)"></div>
                </div>
                <van-uploader :after-read="onRead" accept multiple class="icon-add" ref="addPhone">
                    <div class="addPhone"></div>
                </van-uploader>
            </div>
        </div>
    </div>
    <div class="actions">
        <div class="bottom_action" @click="tijiaoFun">提交评论</div>
    </div>
</div>
</template>

<script>
import Vue from "vue";
import router from "../../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../../.././vuex/mutation_types";
import Bridge from "../../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;
export default {
    // name: "map-index",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            title: this.$route.query.title,
            price: this.$route.query.price,
            count: this.$route.query.count,
            spec: this.$route.query.spec,
            image: this.$route.query.image,
            goodsId: this.$route.query.goodsId, // 商品id
            orderId: this.$route.query.orderId, // 订单id
            comment: '', // 评论
            imglist: [], // 上传回显图片列表
            url: 'http://timemap2.shanmuzhi.com',
            token: null
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            //修改导航栏样式
            var styleParams = {
                'data': {
                    'naviTitle': '商品评价',
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', styleParams, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                // this.getData()
                responseCallback(data)
            })
        } else {
            this.token = this.$store.getters.token
        }
    },
    methods: {
        // 提交
        tijiaoFun() {
            if (!this.comment) {
                this.$toast('评论不能为空');
                return
            }
            var params = {
                token: this.token,
                order_id: this.orderId,
                content: this.comment,
                good_id: this.goodsId,
                parentid: 0, // 上级评论ID，没有添0
                attr: this.imglist // 图片数组
            }
            console.log(params)
            this.$api.shop.addComment(params).then(res => {
                if (res.code == 200) {
                    this.$toast('评论成功')
                    this.$router.back(-1);
                } else {
                    this.$toast(res.message)
                }
            })
        },
        // 图片上传 
        onRead: function (file) {
            console.log("file");
            console.log(file);
            if ($.isArray(file)) {
                for (var i in file) {
                    this.$api.index.uploadImage({
                        imgFile: file[i].content
                    }).then(res => {
                        if (res.code == 200) {
                            this.imglist.push(res.result.url);
                        }
                    });
                }
            } else {
                this.$api.index.uploadImage({
                    imgFile: file.content
                }).then(res => {
                    if (res.code == 200) {
                        this.imglist.push(res.result.url);
                    }
                });
            }
        },
        // 删除图片
        imgDel(index) {
            this.imglist.splice(index, 1);
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.page .upload-images {
    margin-top: .4rem;
}
</style>
